<div class="modal-body">
  <lh-review
    *ngIf="isInitialized"
    [(ngModel)]="review"
    [booking]="booking"
    [externalReviewUrl]="shop.externalReviewUrl"
    (done)="close()"
  >
  </lh-review>

  <div class="text-center">
    <lh-shared-ui-spinner [visible]="!isInitialized || isLoading"></lh-shared-ui-spinner>
  </div>
</div>
